'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _DebugManager = require('../../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _constants = require('../constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Plugin = _video2.default.getPlugin('plugin');
var dmInstance = _DebugManager2.default.dmInstance;
var VideoEvents = Constants.VideoEvents;
// The count of overall cycles allowed. -1 means no limit

var CYCLE_COUNT_LIMIT = 5;

// Number of playlist retries before switching to new master playlist
var RETRY_COUNT_LIMIT = 2;

// Number of seconds to delay error event since they may occur very rapidly
var WAIT_ON_ERROR_INTERVAL = 1;

// Number of seconds between queue check
var QUEUE_CHECK_INTERVAL = 5;

// Number of playback checks before switching to new master playlist
var NO_TIME_COUNT_LIMIT = 1;

// Restart failover this many seconds after CYCLE_COUNT_LIMIT is reached
var RETRY_DELAY = 10;

/**
 * Creates a Failover Plugin to handle player stream failover.
 *
 * @param {Player} player
 *        A Video.js player instance.
 *
 * @param {Object} options
 *        The options to configure the plugin.
 *
 *        Options object should include:
 *
 *        @param {Object} urls
 *        Example smartPathUrls data:
 *        [
 *          { src: 'pathtovideosrc.com', type: 'application/x-mpegURL' },
 *          { src: 'anotherpathtoavideosrc.com', type: 'application/x-mpegURL' }
 *        ]
 *
 *        @param {Function} errorHandler
 *        Error handler when the plugin fires the `FAILOVER_RETRY_LIMIT_REACHED` event.
 *
 */

var FailoverPlugin = function (_Plugin) {
  _inherits(FailoverPlugin, _Plugin);

  function FailoverPlugin(player, options) {
    _classCallCheck(this, FailoverPlugin);

    var _this = _possibleConstructorReturn(this, (FailoverPlugin.__proto__ || Object.getPrototypeOf(FailoverPlugin)).call(this, player, options));

    _this.startFailoverMonitor = function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] startFailoverMonitor()');
      if (!_this.checkInterval) {
        _this.addEventListeners();
        _this.checkInterval = setInterval(_this.processChecks, QUEUE_CHECK_INTERVAL * 1000);
      }
    };

    _this.stopFailoverMonitor = function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] stopFailoverMonitor()');
      _this.removeEventListeners();
      clearInterval(_this.checkInterval);
      _this.checkInterval = null;
    };

    _this.addEventListeners = function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] addEventListeners()');
      if (!_this.player) {
        return;
      }
      _this.player.on(VideoEvents.ERROR_EVENT, function () {
        _this.queue.push(VideoEvents.ERROR_EVENT);
        dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.ERROR_EVENT + '"');
      });
      /*
      * retryplaylist is fired when there is only 1 playlist for the player
      * to choose from. we'll have a buffer here because we don't want to be
      * endlessly trying dead playlists
      */
      _this.player.tech('safe').on(VideoEvents.RETRYPLAYLIST_EVENT, function () {
        dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.RETRYPLAYLIST_EVENT + '", retryCount: ' + _this.retryCount);
        _this.retryCount += 1;
        _this.queue.push(VideoEvents.RETRYPLAYLIST_EVENT);
      });
      /*
      * Blacklists a playlist when an error occurs for a set amount of time
      * making it unavailable for selection by the rendition selection algorithm
      * and then forces a new playlist (rendition) selection.
      */
      _this.player.tech('safe').on(VideoEvents.BLACKLISTPLAYLIST_EVENT, function () {
        dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.BLACKLISTPLAYLIST_EVENT + '", retryCount: ' + _this.retryCount);
        _this.retryCount += 1;
        _this.queue.push(VideoEvents.BLACKLISTPLAYLIST_EVENT);
      });
    };

    _this.removeEventListeners = function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] removeEventListeners()');
      if (!_this.player) {
        return;
      }
      _this.player.off(VideoEvents.ERROR_EVENT);
      _this.player.tech('safe').off(VideoEvents.RETRYPLAYLIST_EVENT);
      _this.player.tech('safe').off(VideoEvents.BLACKLISTPLAYLIST_EVENT);
    };

    _this.processChecks = function () {
      // we don't want to do any checks if video has not started
      if (!_this.player || _this.player && !_this.player.hasStarted()) {
        dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] processChecks(), skipping checks as playback has not started');
        return;
      }

      var type = _this.queue.shift();
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] processChecks(), type: ' + type);
      // if type is undefined, go straight to playhead check
      if (!type) {
        _this.checkPlayback();
        return;
      }
      // left the following verbose so it's easier to follow/debug
      if (type === VideoEvents.ERROR_EVENT) {
        setTimeout(_this.cyclePlaylist, WAIT_ON_ERROR_INTERVAL * 1000);
      }
      if (type === VideoEvents.RETRYPLAYLIST_EVENT) {
        // we have a buffer here so that the server has a chance to switch on it's own
        if (_this.retryCount >= RETRY_COUNT_LIMIT) {
          _this.retryCount = 0;
          _this.cyclePlaylist();
        }
      }
      if (type === VideoEvents.BLACKLISTPLAYLIST_EVENT) {
        // we have a buffer here so that the server has a chance to switch on it's own
        if (_this.retryCount >= RETRY_COUNT_LIMIT) {
          _this.retryCount = 0;
          _this.cyclePlaylist();
        }
      }
    };

    _this.checkPlayback = function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] checkPlayback(), currentTime: ' + _this.player.currentTime() + ', lastPlayerTime: ' + _this.lastPlayerTime);
      if (_this.player.currentTime() === _this.lastPlayerTime) {
        _this.noTimeChangeCount += 1;
        if (_this.noTimeChangeCount === NO_TIME_COUNT_LIMIT) {
          _this.noTimeChangeCount = 0;
          _this.cyclePlaylist();
        }
      } else {
        _this.lastPlayerTime = _this.player.currentTime();
      }
    };

    _this.cyclePlaylist = function () {
      if (!_this.player) return;
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] cyclePlaylist(), current cycle count: ' + _this.totalRetryCount);
      // if we've reached the max cycle limit
      // this will never execute if CYCLE_COUNT_LIMIT is -1
      if (_this.totalRetryCount === CYCLE_COUNT_LIMIT) {
        console.warn(('\n        Attempted to cycle playlists ' + _this.totalRetryCount + ' times.\n        Will attempt again in ' + RETRY_DELAY + ' seconds or you may refresh the page to try again.\n      ').trim());
        _this.errorHandler();
        // stop and restart playback check after RETRY_DELAY seconds
        _this.stopFailoverMonitor();
        setTimeout(_this.startFailoverMonitor, RETRY_DELAY * 1000);
        _this.totalRetryCount = 0;
        return;
      }

      _this.noTimeChangeCount = 0;
      _this.currentIndex += 1;
      _this.totalRetryCount += 1;

      if (_this.currentIndex >= _this.urls.length) {
        _this.currentIndex = 0;
      }

      console.warn('switching to index: ' + _this.currentIndex + ' source: ' + _this.urls[_this.currentIndex].src);
      _this.player.src(_this.urls[_this.currentIndex]);
    };

    var failoverDefaultOptions = {
      CYCLE_COUNT_LIMIT: CYCLE_COUNT_LIMIT,
      RETRY_COUNT_LIMIT: RETRY_COUNT_LIMIT,
      WAIT_ON_ERROR_INTERVAL: WAIT_ON_ERROR_INTERVAL,
      NO_TIME_COUNT_LIMIT: NO_TIME_COUNT_LIMIT,
      RETRY_DELAY: RETRY_DELAY,
      QUEUE_CHECK_INTERVAL: QUEUE_CHECK_INTERVAL
    };

    _this.options = _extends({}, failoverDefaultOptions, options);
    _this.errorHandler = _this.options.errorHandler;

    _this.retryCount = 0;
    _this.totalRetryCount = 0;
    _this.currentIndex = 0;
    _this.lastPlayerTime = 0;
    _this.noTimeChangeCount = 0;
    _this.urls = options.urlList;
    _this.player = player;
    _this.checkInterval = null;

    _this.queue = [];

    // stop failover when player is removed from DOM
    _this.on(VideoEvents.DISPOSE_EVENT, function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.DISPOSE_EVENT + '", stopping failover');
      _this.stopFailoverMonitor();
    });

    // set up playback check and listeners on ready so that
    // if coming to a page, failover will start as soon as
    // player loads
    player.on(VideoEvents.READY_EVENT, function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.READY_EVENT + '", options: ' + _this.options);

      // need to listen for any clicks which may result in a pause
      player.on(VideoEvents.CLICK_EVENT, function () {
        if (player.paused()) {
          _this.stopFailoverMonitor();
        } else {
          _this.startFailoverMonitor();
        }
      });
      _this.startFailoverMonitor();
    });

    // clear out queue/total retry count on successful playback
    player.on(VideoEvents.PLAYING_EVENT, function () {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.F], '[FailoverPlugin] event triggered - "' + VideoEvents.PLAYING_EVENT + '", clearing queue');
      _this.queue = [];
      _this.totalRetryCount = 0;
    });
    return _this;
  }

  /**
  * start failover
  */


  /**
  * stop failover
  */


  /**
  * add event listeners
  * videojs will automatically attempt different renditions if it
  * runs into problems. In my observations, the different renditions are not pulled from
  * different servers since the master playlist contains different bitrate
  * streams from a single server. The player will cycle through the different bitrates
  * in the master manifest until the wowza server can switch to a different encoding.
  * The retryplaylist and blacklistplaylist listeners here to ensure the player is not
  * cycling through dead playlists. Sometimes failover just needs to happen to kick the
  * player out of an endless loop..
  *
  * see https://mediaplatform.atlassian.net/wiki/spaces/TECH/pages/370769921/Videojs+upgrade+considerations
  */

  /**
  * this is a generic check for playhead movement
  */


  /**
  * adjust all variables and try the next url in the list
  */


  return FailoverPlugin;
}(Plugin);

_video2.default.registerPlugin('failoverPlugin', FailoverPlugin);

exports.default = FailoverPlugin;